(() => {
  const layer = document.querySelector('[data-ovia-layer]');
  if (!layer) return;

  const drawers = [...layer.querySelectorAll('[data-ovia-drawer]')];
  let lastTrigger = null;

  const closeAll = () => {
    layer.hidden = true;
    drawers.forEach((drawer) => drawer.hidden = true);
    document.body.classList.remove('ovia-scroll-lock');
    if (lastTrigger) lastTrigger.focus();
  };

  const openDrawer = (name, trigger) => {
    const drawer = drawers.find((item) => item.dataset.oviaDrawer === name);
    if (!drawer) return;
    lastTrigger = trigger || null;
    drawers.forEach((item) => item.hidden = item !== drawer);
    layer.hidden = false;
    document.body.classList.add('ovia-scroll-lock');
    window.requestAnimationFrame(() => {
      const target = drawer.querySelector('input, select, button, a');
      if (target) target.focus();
    });
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-ovia-open]');
    if (open) {
      event.preventDefault();
      openDrawer(open.dataset.oviaOpen, open);
      return;
    }

    if (event.target.closest('[data-ovia-close]')) {
      event.preventDefault();
      closeAll();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !layer.hidden) closeAll();
  });
})();
